import type { SupplierStatus } from '@tandemone/types'

import { Badge } from '@/components/ui/badge'

const STATUS_LABELS: Record<SupplierStatus, string> = {
  onboarding: 'Pending verification',
  active: 'Active',
  suspended: 'Suspended',
  disqualified: 'Disqualified'
}

const STATUS_CLASSES: Record<SupplierStatus, string> = {
  onboarding:
    'bg-yellow-300 text-yellow-950 border-transparent dark:bg-yellow-900 dark:text-yellow-100',
  active:
    'bg-emerald-100 text-emerald-900 border-transparent dark:bg-emerald-950 dark:text-emerald-200',
  suspended:
    'bg-amber-200 text-amber-950 border-transparent dark:bg-amber-900 dark:text-amber-100',
  disqualified:
    'bg-red-100 text-red-900 border-transparent dark:bg-red-950 dark:text-red-200'
}

export function SupplierStatusBadge({ status }: { status: SupplierStatus }) {
  return (
    <Badge className={`shrink-0 ${STATUS_CLASSES[status]}`}>
      {STATUS_LABELS[status]}
    </Badge>
  )
}
